/* eslint-disable react-hooks/exhaustive-deps */
// import TicketMenuManagementCreate from "./lib/create";
import { useParams } from 'react-router';
import { useEffect } from 'react';

import Gap from 'components/gap';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import TicketDetailInfo from './lib/info';
import { useActions } from 'common/hooks/useActions';
import AppLoading from 'components/appLoading';

import * as S from './styles';
// import TicketDetailTypeInfo from './lib/typeInfo';

export default function TicketRequesterItemDetailPage() {
  const { ticketsDetailRequestItem, ticketClose } = useTypedSelector((state: any) => state.Tickets);
  const { ticketDetailRequestItemRequestAction } = useActions();

  const params = useParams();

  useEffect(() => {
    ticketDetailRequestItemRequestAction(params?.id);
  }, []);

  return (
    <S.Container>
      <S.Head>
        <S.Title>Request Detail</S.Title>
      </S.Head>
      <Gap size="20px" />
      <S.Div className="row">
        <S.Div className="col-md-12">
          <TicketDetailInfo data={ticketsDetailRequestItem.data} />
        </S.Div>
      </S.Div>

      <AppLoading loading={ticketsDetailRequestItem.loading || ticketClose.loading} />
    </S.Container>
  );
}
